import { takeEvery } from 'redux-saga/effects';

import * as signInActions from 'store/modules/auth/signIn';
import { checkNotifications } from './utils';

export default function* listenSignIn() {
  yield takeEvery(signInActions.signInSuccess.toString(), checkNotifications);
}
